import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { loadMaestrosMaterialRequest } from './actions';
import { changeUrlLanguage, LanguageId } from './language';
import { FiltersService } from './services';
import { ModuleState } from './state';
import { environment } from '../environments/environment';
import { AuthService }  from '@auth0/auth0-angular';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthState } from './auth/auth.types';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  authState$!: Observable<AuthState>;
  showSideFilters: boolean = false;

  constructor(
    private store: Store<ModuleState>,
    private filtersService: FiltersService,
    private titleService: Title,
    private auth: AuthService
  ) {}

  changeLanguage(language: LanguageId): void {
    //console.log(changeUrlLanguage(language))
    window.location.pathname = changeUrlLanguage(language)
  }

  emitScrollEvent() {
    return this.filtersService.onScrolled$.next();
  }

  ngOnInit(): void {
    this.titleService.setTitle(environment.appTitle);
    // this.store.dispatch(changeLanguage({ language: getLanguageFromUrl() }))
    this.store.dispatch(loadMaestrosMaterialRequest());
    this.store.select((state: ModuleState) => state.ui.showSideFilters).subscribe(show => this.showSideFilters = show);
    // For clean binding in the template.
    this.authState$ = combineLatest([
      this.auth.isAuthenticated$,
      this.auth.user$,
      this.auth.isLoading$
    ]).pipe(
      map(([isAuthenticated, user, loading]) => ({ isAuthenticated, user, loading }))
    );
  }
}